<div *ngIf="loading" class="d-flex loading-spinner"
 >
  <!-- <mat-spinner color="warn" diameter="20"></mat-spinner> -->
  <div class=" eac-label-input">Carregant...</div>
</div>
<mat-drawer-container *ngIf="configAvailable==true"   autosize>
  <mat-drawer #drawer mode="side" [opened]="true" [disableClose]="true">

    <div style="display: flex; justify-content: center; flex-direction: column; height: 100%;">


      <mat-list class="mat-body-1" [class.mylist]="toggle" [class.mylist2]="toggle ==false" >

        <mat-list-item tabindex="0" [matTooltip]="option.name" (keyup.enter)="selectOp(option);doNavigation(option);" [matTooltipDisabled]="toggle==true"
        *ngFor="let option of options"
          (click)="selectOp(option)" [routerLink]="option.path"  style=" min-width: 72px; padding-left: 5px;">
          
          <mat-icon class="valign-center align-items-center eac-c1" [class.selected-primary]="opSelected == option" mat-list-icon>{{option.icon}}
          </mat-icon>
          <span class="valign-center align-items-center" *ngIf="toggle" [class.selected-primary]="opSelected == option">{{option.name}}</span>
          <div *ngIf="opSelected == option" class="position-absolute">
            <div class="app-selected">

            </div>
          </div>

          
        </mat-list-item>


      </mat-list>
      <div (click)="doToggle()" style="flex: 1 0 0; cursor: pointer;"></div>

    </div>
  </mat-drawer>
  <!--
    <div class="example-sidenav-content">
      <button type="button" mat-button (click)="drawer.toggle()">
        Toggle sidenav
      </button>
      
    </div>
  -->

  <div class="body-container">

    <router-outlet></router-outlet>

  </div>



</mat-drawer-container>